import React, { useState, useEffect } from "react";

import { ScrambledSentence,
    NextButton,
    MainContent,
    InputContainer
} from "../components/WordScrambler";

const WordScrambler = () =>  
{
    const [solution, setSolution] = useState("");
    const [solved, isSolved] = useState(false);
    const [endpoint, setEndpoint] = useState(1);
    const [score, setScore] = useState(0);
    const [winStatus, setWinStatus] = useState(false)

    /*
    Solution representaion:
    "Example of Sentence"
    ["Example", "of", "Sentence"]
    */

    const handleClickNext = () =>
    {
        setScore( prev => prev+1 );
        setEndpoint( prev => prev+1 );
    }

    useEffect( () => 
    {
        if (endpoint > 10 )
        {
            setWinStatus(true);
        }
        else
        {
            const fetchData = async () =>
            {
                const url = `https://api.hatchways.io/assessment/sentences/${endpoint}`;
    
                const response = await fetch(url);
                const api = await response.json();
                setSolution(api.data?.sentence.toLowerCase());
            };
    
            fetchData();
        }

    }, [endpoint]);


    
    return (
        <>

                <MainContent>
                { 
                    (winStatus) ? (
                        <p>You win!</p>
                    ) : (
                    <>
                        <ScrambledSentence sentence={solution}></ScrambledSentence>
                        <p >Guess the sentence! Start typing.</p>
                        <p>The yellow blocks are meant for spaces</p>

                        <h2>Score: {score}</h2>
                        
                        {/* If word lenght is >21, the MainContent overflows and scrolls horizontally */}
                        <InputContainer solution={solution} isSolved={isSolved} />
                        { solved && <NextButton handleClickNext={handleClickNext}></NextButton>}
                    </>
                    )
                }
                </MainContent>
        
        </>
    );
}

export default WordScrambler;
